import { useTranslation } from "react-i18next";
import { TriangleAlert } from "lucide-react";
import { Alert, AlertDescription, AlertTitle } from "~/atoms/alert";

export const OffboardWorkflowWarning = () => {
  const { t } = useTranslation();

  return (
    <Alert variant="warn">
      <TriangleAlert />
      <AlertTitle>
        {t(($) => $.settings.userManagement.offboardWorkflowWarningTitle)}
      </AlertTitle>
      <AlertDescription>
        {t(($) => $.settings.userManagement.offboardWorkflowWarningDescription)}
      </AlertDescription>
    </Alert>
  );
};
